import { useEffect, useState } from "react";
import {
  IStandard,
  IStandardAggregations,
} from "@/search/Langston/types/IStandard";
import { gradeLabelToValue } from "@/search/Langston/LangstonParameterSchema/LangstonParameterSchema";

export const useStandardsSetFilter = (
  standards: IStandard[],
  standardAggregations: IStandardAggregations | null,
) => {
  const [currentStandards, setCurrentStandards] = useState<IStandard[]>(
    standards as IStandard[],
  );
  const [filteredStandards, setFilteredStandards] =
    useState<IStandard[]>(standards);
  const [selectedSubjectFilter, setSelectedSubjectFilter] =
    useState<string>("-");
  const [selectedGradeFilter, setSelectedGradeFilter] = useState<string>("-");
  const [selectedDateFilter, setSelectedDateFilter] = useState<string>("-");
  const [availableSubjects, setAvailableSubjects] = useState<string[]>([]);
  const [availableDates, setAvailableDates] = useState<string[]>([]);

  useEffect(() => {
    const getAvailableFilters = () => {
      if (!standardAggregations) return;
      setAvailableSubjects(standardAggregations.subjects);
      setAvailableDates(standardAggregations.years.map(String));
    };

    const getFilteredStandards = () => {
      let filteredStd = currentStandards;

      filteredStd =
        selectedSubjectFilter === "-"
          ? filteredStd
          : filteredStd.filter(
              (standard) => standard.subjects[0] === selectedSubjectFilter,
            );

      const gradeValue = gradeLabelToValue[selectedGradeFilter];
      filteredStd =
        gradeValue === undefined
          ? filteredStd
          : filteredStd.filter((standard) =>
              standard.grade_levels.includes(+gradeValue),
            );

      filteredStd =
        selectedDateFilter === "-"
          ? filteredStd
          : filteredStd.filter(
              (standard) =>
                standard.adoption_year.toString() === selectedDateFilter,
            );

      setFilteredStandards(filteredStd);
    };

    getAvailableFilters();
    getFilteredStandards();
  }, [
    currentStandards,
    selectedSubjectFilter,
    selectedGradeFilter,
    selectedDateFilter,
    standards,
  ]);

  return {
    currentStandards,
    setCurrentStandards,
    filteredStandards,
    setFilteredStandards,
    selectedSubjectFilter,
    setSelectedSubjectFilter,
    selectedGradeFilter,
    setSelectedGradeFilter,
    selectedDateFilter,
    setSelectedDateFilter,
    availableDates,
    availableSubjects,
  };
};
